import c from "../../../utils/constants";
 
class LeftnavController {
  constructor(NavigationService, AppContextService, EventsService) {
    "ngInject"
   
    this.navigationService = NavigationService;
    this.appContextService = AppContextService;
    this.eventsService = EventsService;
    this.displayAdminNav = false;
    this.displayAnalyticsNav = false;
  }
 
  $onInit() {
    this.appContext = this.appContextService.getAppContext();
   
    this.eventsService.listen(c.events.AUTHORIZATION_SUCCESS, () => {
      this.appContext = this.appContextService.getAppContext();
      this.setLeftNavVisibility(this.appContext);
      console.log("AUTHORIZATION_SUCCESS Event listener called", this.appContext)
    })
  }
 
  setLeftNavVisibility(appContext) {
    if (this.appContextService.isAdmin())
      this.displayAdminNav = true;
    if (this.appContextService.isAnalytics())
      this.displayAnalyticsNav = true;
 
    if(appContext && appContext.roles) {
     
      // Check if user has ONLY read access (no admin or global admin)
      if(this.appContextService.hasReadAccess(appContext.roles) &&
         !appContext.roles.includes('Admin') &&
         !appContext.roles.includes('GlobalAdmin'))
        this.hasOnlyReadAccess = true;
      else
        this.hasOnlyReadAccess = false;
 
     
      if(this.appContextService.hasGlobalAdminAccess(appContext.roles))
        this.hasGlobalAdminAccess = true;
      else
        this.hasGlobalAdminAccess = false;
 
    }
  }
 
  isCurrentPage(page) {
    return this.navigationService.isCurrent(page);
  }
 
}
 
export default LeftnavController;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/leftnav/leftnav.controller.js
 **/